import React, { useState } from "react";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { Topbar, Alert } from "@components";
import { TOPUP_LK, WITHDRAW_LK } from "@constants";
import {
  RootContainer,
  InfoBox,
  Text,
  Image,
  ButtonWrapper,
  GroupContainer,
  Item,
  ContinueButton,
  Form,
  CustomAmountContainer,
  CustomAmountTitle,
} from "./FillAmount.style";
import { SHARE_TYPE } from "@constants/shareTypes";
import { Col, Row } from "antd";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import SuccessModal from "./SuccessModal/SuccessModal";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { getFormattedNumber } from "@utils";

const items = [
  1000,
  2000,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  9000,
  10000,
  15000,
  20000,
  25000,
  30000,
  40000,
  50000,
  60000,
  70000,
  80000,
  90000,
  100000,
  200000,
  300000,
  400000,
  500000,
  600000,
  700000,
  800000,
  900000,
  1000000,
];

const FillAmount = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { trx_type } = useParams();
  const { state: account } = useLocation();
  const [amount, setAmount] = useState(items[0]);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [canShare, setCanShare] = useState(0);

  const confirm = () => {
    if (!confirmLoading) {
      setConfirmLoading(true);
      api
        .withdraw({
          amount,
          user_payment_id: account?.user_payment_id,
        })
        .then(({ can_share }) => {
          setCanShare(can_share)
          setConfirmLoading(false);
          handleClose();
          setOpenSuccess(true);
        })
        .catch((errorMsg) => {
          setConfirmLoading(false);
          setOpen(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const successCallback = () => {
    if (canShare === 1) {
      navigate(`/${PRIVATE_ROUTE.SHARE_LINK}/${SHARE_TYPE.WITHDRAW}`);
    } else {
      navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`);
    }
  };

  const onFinish = () => {
    if (trx_type === TOPUP_LK) {
      navigate(`/${PRIVATE_ROUTE.PROCEED_TOPUP}`, {
        state: {
          amount,
          account,
        },
      });
    } else if (trx_type === WITHDRAW_LK) {
      setOpen(true);
    }
  };

  const handleChange = (value) => {
    setAmount(value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const goBack = () => {
    trx_type === TOPUP_LK
      ? navigate(-1)
      : navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const renderAccountInfo = () => {
    if (trx_type === TOPUP_LK) {
      return (
        <InfoBox>
          <Image src={account.image} />
          <Text>{account.name}</Text>
        </InfoBox>
      );
    } else {
      return (
        <InfoBox>
          <Image src={account.payment_category_image} />
          <Text>{account.name}</Text>
        </InfoBox>
      );
    }
  };

  if (!account) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <Topbar
        title={
          trx_type === TOPUP_LK
            ? t("wallet.walletTopUp")
            : t("wallet.walletWithdraw")
        }
        goBack={goBack}
      />
      <RootContainer>
        <Form
          layout="vertical"
          onFinish={onFinish}
          requiredMark={false}
        >
          {renderAccountInfo()}
          <CustomAmountContainer>
            <CustomAmountTitle>{t("wallet.customAmountTitle")}</CustomAmountTitle>
          </CustomAmountContainer>
          <GroupContainer>
            <Row gutter={[12, 12]}>
              {items.map((item, key) => (
                <Col key={key} xs={8}>
                  <Item
                    onClick={() => handleChange(item)}
                    selected={amount === item ? "true" : "false"}
                  >
                    <Text>{getFormattedNumber(item)}</Text>
                  </Item>
                </Col>
              ))}
            </Row>
          </GroupContainer>
          <Form.Item>
            <ButtonWrapper>
              <ContinueButton
                type="primary"
                size="large"
                htmlType="submit"
                amount={isNaN(amount) || amount < 1 ? true : false}
              >
                {t("common.continue")}
              </ContinueButton>
            </ButtonWrapper>
          </Form.Item>
        </Form>
      </RootContainer>
      <ConfirmModal
        open={open}
        loading={confirmLoading}
        handleClose={handleClose}
        onConfirm={confirm}
      />
      <SuccessModal
        open={openSuccess}
        onOk={successCallback}
      />
      <Alert />
    </>
  );
};

export default FillAmount;
